import { __decorate, __extends } from "tslib";
import { injectable } from 'tsyringe';
import { createElement } from '@gn-audio/core/common/templating';
import { BasketPlugin } from '../../models';
import { getBasketTotalCount } from '../../utilities/get-basket-total-count';
import './basket-empty-message.plugin.scss';
import template from './basket-empty-message.plugin.html';
var BasketEmptyMessagePlugin = /** @class */ (function (_super) {
    __extends(BasketEmptyMessagePlugin, _super);
    function BasketEmptyMessagePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reactOnChanges = function (state) {
            var _a;
            var totalCount = getBasketTotalCount(state);
            (_a = _this.element) === null || _a === void 0 ? void 0 : _a.remove();
            if (totalCount === 0) {
                _this.element = _this.target.appendChild(createElement(template, {}, _this.translations));
            }
        };
        return _this;
    }
    BasketEmptyMessagePlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus, state = _a.state, translations = _a.translations;
        this.eventBus = eventBus;
        this.translations = translations;
        this.target = document.querySelector(".basket-ui__content" /* BasketUIElementSelector.BasketContent */);
        this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
        this.reactOnChanges(state);
    };
    BasketEmptyMessagePlugin.prototype.shouldRegister = function () {
        return true;
    };
    BasketEmptyMessagePlugin.prototype.unregister = function () {
        var _a;
        this.eventBus.unsubscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
    };
    BasketEmptyMessagePlugin = __decorate([
        injectable()
    ], BasketEmptyMessagePlugin);
    return BasketEmptyMessagePlugin;
}(BasketPlugin));
export { BasketEmptyMessagePlugin };
